import { ClientWithSecretDto } from '../api/dto'
import { ClientWithSecret } from '../models'

const clientWithSecretToModelTransformer = (dto: ClientWithSecretDto): ClientWithSecret => ({
  id: dto.id,
  clientId: dto.clientId,
  name: dto.name,
  description: dto.description ?? null,
  secret: dto.secret,
})

export default clientWithSecretToModelTransformer
